import { render } from "./PyramidGame.vue?vue&type=template&id=46338d06&scoped=true"
import script from "./PyramidGame.vue?vue&type=script&lang=js"
export * from "./PyramidGame.vue?vue&type=script&lang=js"

import "./PyramidGame.vue?vue&type=style&index=0&id=46338d06&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46338d06"]])

export default __exports__